import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, defineMessages } from 'react-intl';
import format from 'date-fns/format';
import classNames from 'classnames';

const ReviewStatusBar = ({
  reviewData,
  intl: { formatMessage },
}) => {
  const messages = defineMessages({
    published: {
      id: 'reviewstatusbar.published',
      defaultMessage: 'Published',
    },
    rejected: {
      id: 'reviewstatusbar.rejected',
      defaultMessage: 'Rejected',
    },
    processed: {
      id: 'reviewstatusbar.reviewbeingstatus',
      defaultMessage: 'Review Being Processed',
    },
  });

  let status = '';
  const { published, removed, date, has_active_version: hasActiveVersion } = reviewData;

  if (!hasActiveVersion) return false;

  if (published) status = formatMessage(messages.published);
  if (!published) status = formatMessage(messages.processed);
  if (removed) status = formatMessage(messages.rejected);

  return (
    <div
      className={classNames('review-status-bar', {
        rejected: removed,
        approved: published,
        processed: hasActiveVersion && !published,
      })}
    >
      <div>
        <FormattedMessage id="reviewstatusbar.submitted" defaultMessage="Submitted" />
        <span className="ml-1">{format(date, 'MM/DD/YYYY')} -</span>
        <span className="ml-1 review-status">{status}</span>
      </div>
    </div>
  );
};

ReviewStatusBar.propTypes = {
  reviewData: PropTypes.shape({}),
};

ReviewStatusBar.defaultProps = {
  reviewData: '',
};

export default injectIntl(ReviewStatusBar);
